// extracted by mini-css-extract-plugin
export default {"section":"Item_section__jOxyp","timeline":"Item_timeline__kgT9b","item":"Item_item__ScWDb"};